export default __webpack_public_path__ + "static/eup-img-3-9126f29252b1a88e0ad6c040920280a0.png";